import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { Card } from '@mui/material';

export default function CircularProgressStack() {
    return (
        <Stack
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1300,
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
            }}
        >
            <Card sx={{ p: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress color="primary" />
            </Card>
        </Stack>
    );
}